import { CustomInput } from "./CustomInput";
import { SearchIcon } from "../images/SearchIcon";
import { Box } from "@mui/material";
import { useStateWithSearchParams } from "../../hooks/useStateWithSearchParams";
import { useEffect, useRef, useState } from "react";
import { useDebounceValue } from "../../hooks/useDebounceValue";

type SearchParams = {
  search?: string;
};

type Props = {
  maxWidth?: string;
  isDisabled?: boolean;
};

export const InputWithQuery = ({ maxWidth, isDisabled }: Props) => {
  const [value, setValue] = useState<string>("");
  const isFirstRender = useRef(true);

  const debounceValue = useDebounceValue(value);
  const { searchDict, setSearchValue } = useStateWithSearchParams<SearchParams>(
    {
      search: undefined,
    },
  );

  useEffect(() => {
    if (searchDict.search !== debounceValue) {
      setValue(searchDict.search || "");
    }
  }, [searchDict.search]);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
    } else {
      if (searchDict.search !== debounceValue) {
        setSearchValue("search", debounceValue || undefined);
      }
    }
  }, [debounceValue]);

  return (
    <Box sx={{ maxWidth: maxWidth ? maxWidth : "284px" }}>
      <CustomInput
        isDisabled={isDisabled}
        value={value}
        placeholder="Search"
        prefixIcon={<SearchIcon />}
        onChange={setValue}
        clearButton
      />
    </Box>
  );
};
